





















import { Vue, Component, Prop } from 'vue-property-decorator'
import GifLoading from '@/components/loading/gif-loading.vue'
import { CREATIVE_LIST_STATUS } from './../const/common'
import { State, Action } from 'vuex-class'
import { BytedIconRight } from '@byte-design/vue-icons'
import { getters as MediaGetters } from './../pages/media/store'
import { videoStage } from "./../const/media";

@Component({
  name: 'PopupPublishing',
  components: { GifLoading, BytedIconRight }
})
export default class PopupPublishing extends Vue {
  @Prop(Boolean) value!: boolean
  @Prop(Number) stage!: number
  @Prop(Boolean) isShowCreativeLoading: boolean
  @State((state: any) => state.budget.preValidation) preValidation: any;
  @State creativeListStatus!: CREATIVE_LIST_STATUS
  @Action('verify/omitError') omitError: any


  get isReady() {
    return this.stage === videoStage.FINISH;
  }

  get isError(){
    // creative_list 为空的 popup
    return this.creativeListStatus === CREATIVE_LIST_STATUS.ERROR
  }

  get curConfig(): Record<string, string | boolean> {
    return this.textConfig[this.stage] || {
      desc: '',
      closable: true,
      title: ''
    };
  }

  get textConfig() {
    return {
      [videoStage.FINISH]: this.value
        ? {
          desc: this.$t('module_precheck_loading_text'),
          closable: true
        }
        : {
          title: this.$t('module_create_ads_submit_loading_title'),
          desc: this.$t('module_create_ads_submit_loading_desc'),
          closable: false
        },
      [videoStage.INIT]: {
        desc: this.$t('module_create_ads_submit_creative_err'),
        closable: true
      },
      [videoStage.OPTIMIZE]: {
        desc: this.$t('module_create_ads_submit_creative_load'),
        closable: true
      },
      [videoStage.UPLOADING]: {
        desc: this.$t('module_create_ads_submit_creative_load'),
        closable: true
      }
    }
  }

  onClose() {
    this.$emit('close')
    this.$emit('input', false)
  }

  goToCreative(){
    this.onClose()
    this.$router.push({ name: 'creative', query: this.$route.query })
  }
}
